import { lazy } from 'react';
/** Открывает карточку заказа */
export const OrderDetailsPageAsync = lazy(() => import('./OrderDetails/OrderDetailsPage'));